import React from "react";
/** Services Import */
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
import Dialog from "../../Services/Common/Dialog";
import IndexedDb from "../../Services/IndexedDb/IndexedDb";
/** Components Import */
import Bm10030View from "../../Views/Bases/BM10030";
import Bm10031View from "../../Views/Bases/BM10031";
import Snackbar from "../../Components/Snackbar";

function BM10030() {
  const [snackbars, setSnackbars] = React.useState({
    toggle: false,
    type: "",
    message: "",
  });
  const [tabToggle, setTabToggle] = React.useState(false);
  const [gridToggle, setGridTggle] = React.useState(false);
  const [gridToggle1, setGridTggle1] = React.useState(false);
  const [inputs, setInputs] = React.useState({
    comboList: [],
    comboValue: "",
    comboList1: [],
    comboValue1: "",
    checkingValue: "",
    checkingResult: false,
  });
  const { comboList, comboValue, comboList1, comboValue1 } = inputs;
  const [saveGroups, setSaveGroups] = React.useState([]);
  const [lanData, setLanData] = React.useState([]);
  const [menuRowData, setMenuRowData] = React.useState([]);
  const [rowData, setRowData] = React.useState([]);
  const [rowData1, setRowData1] = React.useState([]);
  const [rowData2, setRowData2] = React.useState([]);
  const [rowData3, setRowData3] = React.useState([]);
  const [changedRowData, setChangedRowData] = React.useState([]);
  const [selectedRowData, setSelectedRowData] = React.useState([]);
  const [changedRowData1, setChangedRowData1] = React.useState([]);
  const [selectedRowData1, setSelectedRowData1] = React.useState([]);
  const [changedRowData2, setChangedRowData2] = React.useState([]);
  const [selectedRowData2, setSelectedRowData2] = React.useState([]);
  const [selectedRowData3, setSelectedRowData3] = React.useState([]);
  const menuGridColumnDef = [
    {
      field: "lcategoCd",
      headerName:
        lanData.length > 0
          ? lanData.filter(
              (f) => f.lanId === "Col_Lcategory" && f.lanType === "COL"
            )[0].lanName
          : "",
      //headerCheckboxSelection: true,
      //checkboxSelection: true,
      minWidth: 200,
    },
    {
      field: "mcategoCd",
      headerName:
        lanData.length > 0
          ? lanData.filter(
              (f) => f.lanId === "Col_Mcategory" && f.lanType === "COL"
            )[0].lanName
          : "",
    },
    {
      field: "scategoCd",
      headerName:
        lanData.length > 0
          ? lanData.filter(
              (f) => f.lanId === "Col_Scategory" && f.lanType === "COL"
            )[0].lanName
          : "",
    },
    {
      field: "detailCd",
      headerName:
        lanData.length > 0
          ? lanData.filter(
              (f) => f.lanId === "Col_DetailCd" && f.lanType === "COL"
            )[0].lanName
          : "",
      minWidth: 180,
    },
    {
      field: "detailNm",
      headerName:
        lanData.length > 0
          ? lanData.filter(
              (f) => f.lanId === "Col_DetailNm" && f.lanType === "COL"
            )[0].lanName
          : "",
      minWidth: 180,
    },
    {
      field: "createYn",
      headerName:
        lanData.length > 0
          ? lanData.filter(
              (f) => f.lanId === "Col_CreateYn" && f.lanType === "COL"
            )[0].lanName
          : "",
    },
    {
      field: "readYn",
      headerName:
        lanData.length > 0
          ? lanData.filter(
              (f) => f.lanId === "Col_ReadYn" && f.lanType === "COL"
            )[0].lanName
          : "",
    },
    {
      field: "updateYn",
      headerName:
        lanData.length > 0
          ? lanData.filter(
              (f) => f.lanId === "Col_UpdateYn" && f.lanType === "COL"
            )[0].lanName
          : "",
    },
    {
      field: "deleteYn",
      headerName:
        lanData.length > 0
          ? lanData.filter(
              (f) => f.lanId === "Col_DeleteYn" && f.lanType === "COL"
            )[0].lanName
          : "",
    },
    {
      field: "printYn",
      headerName:
        lanData.length > 0
          ? lanData.filter(
              (f) => f.lanId === "Col_PrintYn" && f.lanType === "COL"
            )[0].lanName
          : "",
    },
    {
      field: "excelYn",
      headerName:
        lanData.length > 0
          ? lanData.filter(
              (f) => f.lanId === "Col_ExcelYn" && f.lanType === "COL"
            )[0].lanName
          : "",
    },
    {
      field: "pdfYn",
      headerName:
        lanData.length > 0
          ? lanData.filter(
              (f) => f.lanId === "Col_PDAYn" && f.lanType === "COL"
            )[0].lanName
          : "",
    },
  ];
  const [selectedMenuRows, setSelectedMenuRows] = React.useState([]);
  const [selectedMenuRows1, setSelectedMenuRows1] = React.useState([]);

  React.useEffect(() => {
    window.addEventListener("error", (e) => {
      if (e.message === "ResizeObserver loop limit exceeded") {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client- overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
    Init();
  }, []);

  const Init = async () => {
    Dialog.ProgressBar(true);
    let getLanData = [];
    let getRowData = [];
    let getComboData = [];
    let getRowData1 = [];
    let getComboData1 = [];

    try {
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });
      setLanData(getLanData);

      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10030.CheckMenu
      ).then((result) => {
        let data = result.data;
        data.push(
          {
            lcategoCd: "BaseManagement",
            mcategoCd: "BM10000",
            scategoCd: "BM10000",
            detailCd: "BM10000",
            detailNm: "기초관리",
            screenType: "L",
          },
          {
            lcategoCd: "DashboardManagement",
            mcategoCd: "DB10000",
            scategoCd: "DB10000",
            detailCd: "DB10000",
            detailNm: "대시보드관리",
            screenType: "L",
          },
          {
            lcategoCd: "ManufactureManagement",
            mcategoCd: "MM10000",
            scategoCd: "MM10000",
            detailCd: "MM10000",
            detailNm: "생산관리",
            screenType: "L",
          },
          {
            lcategoCd: "PurchaseManagement",
            mcategoCd: "PM10000",
            scategoCd: "PM10000",
            detailCd: "PM10000",
            detailNm: "구매관리",
            screenType: "L",
          },
          {
            lcategoCd: "SalesManagement",
            mcategoCd: "SM10000",
            scategoCd: "SM10000",
            detailCd: "SM10000",
            detailNm: "영업관리",
            screenType: "L",
          },
          {
            lcategoCd: "StockManagement",
            mcategoCd: "ST10000",
            scategoCd: "ST10000",
            detailCd: "ST10000",
            detailNm: "재고관리",
            screenType: "L",
          }
        );
        if (data.length > 0) {
          setMenuRowData(data);
        }
      });

      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10030.GetGroup
      ).then((result) => {
        let data = result.data;

        for (let i = 0; i < data.length; i++) {
          getRowData.push({
            authGroupCd: data[i].authGroupCd,
            authGroupNm: data[i].authGroupNm,
            createDate: data[i].createDate
              ? Commons.DateFormating(data[i].createDate.toString(), 2)
              : "",
            createId: data[i].createId,
            updateDate: data[i].updateDate
              ? Commons.DateFormating(data[i].updateDate.toString(), 2)
              : "",
            updateId: data[i].updateId,
          });
          getComboData.push({
            value: data[i].authGroupCd,
            name: data[i].authGroupNm,
          });
        }
      });

      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10031.GetMember
      ).then((result) => {
        let data = result.data;

        for (let i = 0; i < data.length; i++) {
          getRowData1.push({
            createDate: data[i].createDate
              ? Commons.DateFormating(data[i].createDate.toString(), 2)
              : "",
            createId: data[i].createId,
            password: data[i].password,
            updateDate: data[i].updateDate
              ? Commons.DateFormating(data[i].updateDate.toString(), 2)
              : "",
            updateId: data[i].updateId,
            useYn: data[i].useYn,
            userId: data[i].userId,
            userNm: data[i].userNm,
          });
          getComboData1.push({
            value: data[i].userId,
            name: data[i].userNm,
          });
        }
      });

      setRowData(getRowData);
      setRowData2(getRowData1);
      setInputs({
        ...inputs,
        comboList: [
          {
            value: "",
            name: "선택해주세요.",
            disabled: true,
            selected: true,
          },
          ...getComboData,
        ],
        comboList1: [
          {
            value: "",
            name: "선택해주세요.",
            disabled: true,
            selected: true,
          },
          ...getComboData1,
        ],
      });
    } catch (e) {
      if (e.response.status === 401) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "로그인 정보가 만료되었습니다.",
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: e.message,
        });
      }
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const CheckingAuthGroup = async () => {
    Dialog.ProgressBar(true);

    try {
      if (!inputs.checkingValue) {
        setSnackbars({
          toggle: true,
          type: "info",
          message: lanData.filter(
            (f) =>
              f.lanId === "Snack_CheckAuthGroupCode" && f.lanType === "SNACK"
          )[0].lanName,
        });
        return false;
      }
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl +
          Global.urls.logic.Bases.BM10030.CheckAuthGroupCd,
        {
          authGroupCd: inputs.checkingValue,
        }
      ).then((result) => {
        let data = result.data;

        if (data === true) {
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_UseokCode" && f.lanType === "SNACK"
            )[0].lanName,
          });
          setInputs({
            ...inputs,
            checkingResult: true,
          });
        } else {
          setSnackbars({
            toggle: true,
            type: "error",
            message: lanData.filter(
              (f) => f.lanId === "Snack_UsenoCode" && f.lanType === "SNACK"
            )[0].lanName,
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const AuthGroupCodeSearch = async (_authGroupCd, _type = "") => {
    Dialog.ProgressBar(true);
    let getData = [];

    try {
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10030.GetAuthGroup,
        { AuthGroupCd: _authGroupCd }
      ).then((result) => {
        let data = result.data;

        if (data === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
          setRowData1([]);
        } else if (data.type === "Error") {
          setRowData1([]);
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else {
          for (let i = 0; i < data.length; i++) {
            getData.push({
              authGroupCd: data[i].authGroupCd,
              createId: data[i].createId,
              createYn:
                data[i].createYn === "Y"
                  ? true
                  : data[i].createYn === "X"
                  ? "X"
                  : false,
              deleteYn:
                data[i].deleteYn === "Y"
                  ? true
                  : data[i].deleteYn === "X"
                  ? "X"
                  : false,
              detailCd: data[i].detailCd,
              detailNm: data[i].detailNm,
              excelYn:
                data[i].excelYn === "Y"
                  ? true
                  : data[i].excelYn === "X"
                  ? "X"
                  : false,
              lcategoCd: data[i].lcategoCd,
              mcategoCd: data[i].mcategoCd,
              pdfYn:
                data[i].pdfYn === "Y"
                  ? true
                  : data[i].pdfYn === "X"
                  ? "X"
                  : false,
              printYn:
                data[i].printYn === "Y"
                  ? true
                  : data[i].printYn === "X"
                  ? "X"
                  : false,
              readYn:
                data[i].readYn === "Y"
                  ? true
                  : data[i].readYn === "X"
                  ? "X"
                  : false,
              scategoCd: data[i].scategoCd,
              screenType: data[i].screenType,
              updateYn:
                data[i].updateYn === "Y"
                  ? true
                  : data[i].updateYn === "X"
                  ? "X"
                  : false,
            });
          }

          setRowData1(Commons.InsertNumber(getData));
          if (_type !== "none") {
            setSnackbars({
              toggle: true,
              type: "success",
              message: lanData.filter(
                (f) => f.lanId === "Snack_Search" && f.lanType === "SNACK"
              )[0].lanName,
            });
          }
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const AuthMemberSearch = async (_authMember) => {
    Dialog.ProgressBar(true);
    let getData = [];

    try {
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl +
          Global.urls.logic.Bases.BM10031.GetAuthMember,
        {
          UserId: _authMember,
        }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          setRowData3([]);
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else if (data.type === "Error") {
          setRowData1([]);
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else {
          for (let i = 0; i < data.length; i++) {
            getData.push({
              userId: data[i].userId,
              createId: data[i].createId,
              createYn:
                data[i].createYn === "Y"
                  ? true
                  : data[i].createYn === "X"
                  ? "X"
                  : false,
              deleteYn:
                data[i].deleteYn === "Y"
                  ? true
                  : data[i].deleteYn === "X"
                  ? "X"
                  : false,
              detailCd: data[i].detailCd,
              excelYn:
                data[i].excelYn === "Y"
                  ? true
                  : data[i].excelYn === "X"
                  ? "X"
                  : false,
              lcategoCd: data[i].lcategoCd,
              mcategoCd: data[i].mcategoCd,
              pdfYn:
                data[i].pdfYn === "Y"
                  ? true
                  : data[i].pdfYn === "X"
                  ? "X"
                  : false,
              printYn:
                data[i].printYn === "Y"
                  ? true
                  : data[i].printYn === "X"
                  ? "X"
                  : false,
              readYn:
                data[i].readYn === "Y"
                  ? true
                  : data[i].readYn === "X"
                  ? "X"
                  : false,
              screenType: data[i].screenType,
              updateYn:
                data[i].updateYn === "Y"
                  ? true
                  : data[i].updateYn === "X"
                  ? "X"
                  : false,
            });
          }

          setRowData3(Commons.InsertNumber(getData));
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_Search" && f.lanType === "SNACK"
            )[0].lanName,
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const CopyLogic = async () => {
    Dialog.ProgressBar(true);
    let getSelectionData = [];
    let userInfo = null;

    try {
      if (selectedRowData.length < 1) {
        throw new Error("권한그룹을 선택하세요.");
      }
      if (!comboValue) {
        throw new Error("콤보박스를 선택하세요.");
      }

      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });

      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10030.GetAuthGroup,
        { authGroupCd: comboValue }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else if (data.type === "Error") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else {
          for (let i = 0; i < data.length; i++) {
            getSelectionData.push({
              authGroupCd: selectedRowData[0].authGroupCd,
              lcategoCd: data[i].lcategoCd,
              mcategoCd: data[i].mcategoCd,
              scategoCd: data[i].mcategoCd,
              detailCd: data[i].detailCd,
              createYn: data[i].createYn,
              readYn: data[i].readYn,
              updateYn: data[i].updateYn,
              deleteYn: data[i].deleteYn,
              printYn: data[i].printYn,
              excelYn: data[i].excelYn,
              pdfYn: data[i].pdfYn,
              screenType: data[i].screenType,
              createDate: new Date(),
              createId: userInfo.userId,
              updateDate: new Date(),
              updateId: userInfo.userId,
            });
          }
        }
      });
      await Commons.Axios(
        "post1",
        Global.serverUrls.useUrl +
          Global.urls.logic.Bases.BM10030.CreateAuthGroup,
        getSelectionData
      ).then((result) => {
        let data = result.data;

        if (data.type === "Error") {
          throw new Error(data.message);
        } else if (data !== "Ok") {
          throw new Error(data);
        } else {
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_Copy" && f.lanType === "SNACK"
            )[0].lanName,
          });
          AuthGroupCodeSearch(selectedRowData[0].authGroupCd, "none");
          setInputs({
            ...inputs,
            comboValue: "",
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const CopyLogic1 = async () => {
    Dialog.ProgressBar(true);
    let getSelectionData = [];
    let userInfo = null;

    try {
      if (selectedRowData2.length < 1) {
        throw new Error("사용자를 선택하세요.");
      }
      if (!comboValue1) {
        throw new Error("콤보박스를 선택하세요.");
      }

      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });

      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl +
          Global.urls.logic.Bases.BM10031.GetAuthMember,
        { UserId: comboValue1 }
      ).then((result) => {
        let data = result.data;

        for (let i = 0; i < data.length; i++) {
          getSelectionData.push({
            userId: selectedRowData2[0].userId,
            createId: data[i].createId,
            createYn: data[i].createYn,
            deleteYn: data[i].deleteYn,
            detailCd: data[i].detailCd,
            excelYn: data[i].excelYn,
            lcategoCd: data[i].lcategoCd,
            mcategoCd: data[i].mcategoCd,
            pdfYn: data[i].pdfYn,
            printYn: data[i].printYn,
            readYn: data[i].readYn,
            screenType: data[i].screenType,
            updateYn: data[i].updateYn,
            createDate: new Date(),
            updateDate: new Date(),
            updateId: userInfo.userId,
          });
        }
      });

      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl +
          Global.urls.logic.Bases.BM10031.CreateAuthMember,
        getSelectionData
      ).then((result) => {
        let data = result.data;

        if (data.type === "Error") {
          throw new Error(data.message);
        } else if (data !== "Ok") {
          throw new Error(data);
        } else {
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_Copy" && f.lanType === "SNACK"
            )[0].lanName,
          });
          AuthMemberSearch(selectedRowData2[0].userId);
          setInputs({
            ...inputs,
            comboValue1: "",
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const SaveConfirm = (_type) => {
    Dialog.Confirm(
      lanData.filter(
        (f) => f.lanId === "Dia_Title_Save" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Message_Save" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Btn_Confirm" && f.lanType === "DIALOG"
      )[0].lanName,
      () => {
        switch (_type) {
          case "grid":
            SaveLogic();
            break;
          case "grid1":
            SaveLogic1();
            break;
          case "grid3":
            SaveLogic3();
            break;
        }
      }
    );
  };

  const SaveLogic = async () => {
    Dialog.ProgressBar(true);
    let userInfo = null;
    let updateData = Commons.Deduplication(changedRowData);
    let saveData = [];

    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });
      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10030.CreateGroup,
        updateData.length === 0 ? saveGroups : updateData
      ).then((result) => {
        let data = result.data;

        if (data !== "Ok") {
          setSnackbars({
            toggle: true,
            type: "error",
            message: data,
          });
        } else if (data.type === "Error") {
          throw new Error(data.message);
        } else {
          Init();
          setChangedRowData([]);
          setSaveGroups([]);
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_Save" && f.lanType === "SNACK"
            )[0].lanName,
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const SaveLogic1 = async () => {
    Dialog.ProgressBar(true);
    let userInfo = null;
    let pushData = [];
    let updateData = Commons.Deduplication(changedRowData1);

    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });

      for (let i = 0; i < updateData.length; i++) {
        if (!updateData[i].screenType) {
          throw new Error("화면분류를 확인하세요.");
        }
        pushData.push({
          authGroupCd: updateData[i].authGroupCd,
          lcategoCd: updateData[i].lcategoCd,
          mcategoCd: updateData[i].mcategoCd,
          scategoCd: updateData[i].scategoCd,
          detailCd: updateData[i].detailCd,
          createYn:
            updateData[i].createYn == "Y" || updateData[i].createYn == true
              ? "Y"
              : "N",
          readYn:
            updateData[i].readYn == "Y" || updateData[i].readYn == true
              ? "Y"
              : "N",
          updateYn:
            updateData[i].updateYn == "Y" || updateData[i].updateYn == true
              ? "Y"
              : "N",
          deleteYn:
            updateData[i].deleteYn == "Y" || updateData[i].deleteYn == true
              ? "Y"
              : "N",
          printYn:
            updateData[i].printYn == "Y" || updateData[i].printYn == true
              ? "Y"
              : "N",
          excelYn:
            updateData[i].excelYn == "Y" || updateData[i].excelYn == true
              ? "Y"
              : "N",
          pdfYn:
            updateData[i].pdfYn == "Y" || updateData[i].pdfYn == true
              ? "Y"
              : "N",
          screenType: updateData[i].screenType,
          createDate: updateData[i].createDate
            ? updateData[i].createDate
            : new Date(),
          createId: updateData[i].createId,
          updateDate: new Date(),
          updateId: userInfo.userId,
        });
      }

      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl +
          Global.urls.logic.Bases.BM10030.CreateAuthGroup,
        pushData
      ).then((result) => {
        let data = result.data;

        if (data !== "Ok") {
          setSnackbars({
            toggle: true,
            type: "error",
            message: data,
          });
        } else if (data.type === "Error") {
          throw new Error(data.message);
        } else {
          AuthGroupCodeSearch(selectedRowData[0].authGroupCd, "none");
          setChangedRowData1([]);
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_Save" && f.lanType === "SNACK"
            )[0].lanName,
          });
          setSelectedMenuRows([]);
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const SaveLogic3 = async () => {
    Dialog.ProgressBar(true);
    let userInfo = null;
    let pushData = [];
    let updateData = Commons.Deduplication(changedRowData2);

    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });

      for (let i = 0; i < updateData.length; i++) {
        if (!updateData[i].screenType) {
          throw new Error("화면분류를 확인하세요.");
        }
        pushData.push({
          userId: updateData[i].userId,
          lcategoCd: updateData[i].lcategoCd,
          mcategoCd: updateData[i].mcategoCd,
          scategoCd: updateData[i].scategoCd,
          detailCd: updateData[i].detailCd,
          createYn: updateData[i].createYn ? "Y" : "N",
          readYn: updateData[i].readYn ? "Y" : "N",
          updateYn: updateData[i].updateYn ? "Y" : "N",
          deleteYn: updateData[i].deleteYn ? "Y" : "N",
          printYn: updateData[i].printYn ? "Y" : "N",
          excelYn: updateData[i].excelYn ? "Y" : "N",
          pdfYn: updateData[i].pdfYn ? "Y" : "N",
          screenType: updateData[i].screenType,
          createDate: new Date(),
          createId: userInfo.userId,
          updateDate: new Date(),
          updateId: userInfo.userId,
        });
      }

      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl +
          Global.urls.logic.Bases.BM10031.CreateAuthMember,
        pushData
      ).then((result) => {
        let data = result.data;

        if (data !== "Ok") {
          setSnackbars({
            toggle: true,
            type: "error",
            message: data,
          });
        } else if (data.type === "Error") {
          throw new Error(data.message);
        } else {
          AuthMemberSearch(selectedRowData2[0].userId);
          setChangedRowData2([]);
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_Save" && f.lanType === "SNACK"
            )[0].lanName,
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const DeleteConfirm = (_type) => {
    Dialog.Confirm(
      lanData.filter(
        (f) => f.lanId === "Dia_Title_Delete" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Message_Delete" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Btn_Confirm" && f.lanType === "DIALOG"
      )[0].lanName,
      () => {
        switch (_type) {
          case "grid":
            DeleteLogic();
            break;
          case "grid1":
            DeleteLogic1();
            break;
          case "grid3":
            DeleteLogic3();
            break;
        }
      }
    );
  };

  const DeleteLogic = async () => {
    Dialog.ProgressBar(true);
    let userInfo = null;

    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });

      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10030.DeleteGroup,
        [
          {
            authGroupCd: selectedRowData[0].authGroupCd,
            authGroupNm: selectedRowData[0].authGroupNm,
            createDate: selectedRowData[0].createDate,
            createId: selectedRowData[0].createId,
            updateDate: selectedRowData[0].updateDate,
            updateId: userInfo.userId,
          },
        ]
      ).then((result) => {
        let data = result.data;

        if (data !== "Ok") {
          setSnackbars({
            toggle: true,
            type: "error",
            message: data,
          });
        } else if (data.type === "Error") {
          throw new Error(data.message);
        } else {
          Init();
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_Delete" && f.lanType === "SNACK"
            )[0].lanName,
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const DeleteLogic1 = async () => {
    Dialog.ProgressBar(true);
    let pushData = [];
    try {
      for (let i = 0; i < selectedRowData1.length; i++) {
        pushData.push({
          authGroupCd: selectedRowData1[i].authGroupCd,
          lcategoCd: selectedRowData1[i].lcategoCd,
          mcategoCd: selectedRowData1[i].mcategoCd,
          scategoCd: selectedRowData1[i].scategoCd,
          detailCd: selectedRowData1[i].detailCd,
          createYn: selectedRowData1[i].createYn ? "Y" : "N",
          readYn: selectedRowData1[i].readYn ? "Y" : "N",
          updateYn: selectedRowData1[i].updateYn ? "Y" : "N",
          deleteYn: selectedRowData1[i].deleteYn ? "Y" : "N",
          printYn: selectedRowData1[i].printYn ? "Y" : "N",
          excelYn: selectedRowData1[i].excelYn ? "Y" : "N",
          pdfYn: selectedRowData1[i].pdfYn ? "Y" : "N",
          screenType: selectedRowData1[i].screenType,
          createDate: selectedRowData1[i].createDate
            ? selectedRowData1[i].createDate
            : new Date(),
          createId: selectedRowData1[i].createId,
          updateDate: selectedRowData1[i].updateDate
            ? selectedRowData1[i].updateDate
            : new Date(),
          updateId: selectedRowData1[i].updateId,
        });
      }

      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl +
          Global.urls.logic.Bases.BM10030.DeleteAuthGroup,
        pushData
      ).then((result) => {
        let data = result.data;

        if (data !== "Ok") {
          setSnackbars({
            toggle: true,
            type: "error",
            message: data,
          });
        } else if (data.type === "Error") {
          throw new Error(data.message);
        } else {
          AuthGroupCodeSearch(selectedRowData[0].authGroupCd, "none");
          setSelectedRowData1([]);
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_Delete" && f.lanType === "SNACK"
            )[0].lanName,
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const DeleteLogic3 = async () => {
    Dialog.ProgressBar(true);
    let pushData = [];

    try {
      for (let i = 0; i < selectedRowData3.length; i++) {
        pushData.push({
          userId: selectedRowData3[i].userId,
          lcategoCd: selectedRowData3[i].lcategoCd,
          mcategoCd: selectedRowData3[i].mcategoCd,
          scategoCd: selectedRowData3[i].scategoCd,
          detailCd: selectedRowData3[i].detailCd,
          createYn: selectedRowData3[i].createYn ? "Y" : "N",
          readYn: selectedRowData3[i].readYn ? "Y" : "N",
          updateYn: selectedRowData3[i].updateYn ? "Y" : "N",
          deleteYn: selectedRowData3[i].deleteYn ? "Y" : "N",
          printYn: selectedRowData3[i].printYn ? "Y" : "N",
          excelYn: selectedRowData3[i].excelYn ? "Y" : "N",
          pdfYn: selectedRowData3[i].pdfYn ? "Y" : "N",
          screenType: selectedRowData3[i].screenType,
          createDate: selectedRowData3[i].createDate
            ? selectedRowData3[i].createDate
            : new Date(),
          createId: selectedRowData3[i].createId,
          updateDate: selectedRowData3[i].updateDate
            ? selectedRowData3[i].updateDate
            : new Date(),
          updateId: selectedRowData3[i].updateId,
        });
      }

      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl +
          Global.urls.logic.Bases.BM10031.DeleteAuthMember,
        pushData
      ).then((result) => {
        let data = result.data;

        if (data !== "Ok") {
          setSnackbars({
            toggle: true,
            type: "error",
            message: data,
          });
        } else if (data.type === "Error") {
          throw new Error(data.message);
        } else {
          AuthMemberSearch(selectedRowData2[0].userId);
          setSelectedRowData3([]);
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_Delete" && f.lanType === "SNACK"
            )[0].lanName,
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  return (
    <div className="card">
      {/* <ul className="tab_nav" style={{ marginTop: "5px" }}>
        <li>
          <a
            className={tabToggle ? "" : "active"}
            onClick={() => setTabToggle(false)}
          >
            {lanData.length > 0
              ? lanData.filter(
                  (f) => f.lanId === "Dia_AuthGroupCd" && f.lanType === "DIALOG"
                )[0].lanName
              : ""}
          </a>
        </li>
        <li>
          <a
            className={!tabToggle ? "" : "active"}
            onClick={() => setTabToggle(true)}
          >
            {lanData.length > 0
              ? lanData.filter(
                  (f) => f.lanId === "Dia_AuthMember" && f.lanType === "DIALOG"
                )[0].lanName
              : ""}
          </a>
        </li>
      </ul>
      {!tabToggle ? ( */}
      <Bm10030View
        Init={Init}
        lanData={lanData}
        rowData={rowData}
        setRowData={setRowData}
        rowData1={rowData1}
        setRowData1={setRowData1}
        changedRowData={changedRowData}
        setChangedRowData={setChangedRowData}
        selectedRowData={selectedRowData}
        setSelectedRowData={setSelectedRowData}
        changedRowData1={changedRowData1}
        setChangedRowData1={setChangedRowData1}
        selectedRowData1={selectedRowData1}
        setSelectedRowData1={setSelectedRowData1}
        AuthGroupCodeSearch={AuthGroupCodeSearch}
        comboList={comboList}
        inputs={inputs}
        setInputs={setInputs}
        CopyLogic={CopyLogic}
        SaveConfirm={SaveConfirm}
        DeleteConfirm={DeleteConfirm}
        CheckingAuthGroup={CheckingAuthGroup}
        gridToggle={gridToggle}
        setGridTggle={setGridTggle}
        menuGridColumnDef={menuGridColumnDef}
        menuRowData={menuRowData}
        selectedMenuRows={selectedMenuRows}
        setSelectedMenuRows={setSelectedMenuRows}
        saveGroups={saveGroups}
        setSaveGroups={setSaveGroups}
      />
      {/* ) : (
        <Bm10031View
          Init={Init}
          lanData={lanData}
          rowData={rowData2}
          setRowData={setRowData2}
          rowData1={rowData3}
          setRowData1={setRowData3}
          changedRowData={changedRowData2}
          setChangedRowData={setChangedRowData2}
          selectedRowData={selectedRowData2}
          setSelectedRowData={setSelectedRowData2}
          selectedRowData1={selectedRowData3}
          setSelectedRowData1={setSelectedRowData3}
          AuthMemberSearch={AuthMemberSearch}
          comboList={comboList1}
          inputs={inputs}
          setInputs={setInputs}
          CopyLogic={CopyLogic1}
          SaveConfirm={SaveConfirm}
          DeleteConfirm={DeleteConfirm}
          gridToggle={gridToggle1}
          setGridTggle={setGridTggle1}
          menuGridColumnDef={menuGridColumnDef}
          menuRowData={menuRowData}
          selectedMenuRows={selectedMenuRows1}
          setSelectedMenuRows={setSelectedMenuRows1}
        />
      )} */}
      {snackbars.toggle && (
        <Snackbar snackbars={snackbars} setSnackbars={setSnackbars} />
      )}
    </div>
  );
}

export default BM10030;
